import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/payment-transactions')({
  component: () => <Outlet />,
})
